module.exports = __webpack_public_path__ + "img/mobile-logo.c97e31e6.png";